import { NotTranslated } from '@execonline-inc/translations';
import { observer } from 'mobx-react';
import { T } from '../../../../Translations';
import CloseIcon from '../../../Cutesies/CloseIcon';
import GroupAvatar from '../../../Cutesies/GroupAvatar';
import { GroupOrParticipantResource } from '../DeepLinks/DeepLinksBody/InviteParticipantModal/Types';
import ParticipantAvatar from '../ParticipantAvatar';
import { getAvatar } from '../Functions';
import { emptyFragment } from '../../../../EmptyFragment';

export interface Props {
  groupOrParticipant: GroupOrParticipantResource;
  removeGroup: (id: number) => void;
  removeParticipant: (id: number) => void;
}

function User({ groupOrParticipant, removeGroup, removeParticipant }: Props) {
  switch (groupOrParticipant.payload.kind) {
    case 'group-participants':
      const group = groupOrParticipant.payload;
      return (
        <div className="flex pt-2 justify-between items-center" key={group.id}>
          <div className="flex">
            <div className="w-8 h-8 mr-2 my-auto">
              <GroupAvatar />
            </div>
            <div className="flex flex-col">
              <p>
                <NotTranslated text={group.name} />
              </p>
              <p>
                <T kind="{{count}} Participant" count={group.totalParticipantsCount} />
              </p>
            </div>
          </div>
          <div className="cursor-pointer" onClick={() => removeGroup(group.id)}>
            <CloseIcon />
          </div>
        </div>
      );
    case 'participant':
      const participant = groupOrParticipant.payload;
      return (
        <div className="flex pt-2 justify-between items-center" key={participant.id}>
          <div className="flex">
            <div className="w-8 h-8 mr-2 my-auto">
              <ParticipantAvatar avatar={getAvatar(groupOrParticipant.links, participant)} />
            </div>
            <div className="flex flex-col">
              {participant.fullName
                .map((name) => (
                  <p>
                    <NotTranslated text={name} />
                  </p>
                ))
                .getOrElse(emptyFragment)}
              <p>
                <NotTranslated text={participant.email} />
              </p>
            </div>
          </div>
          <div className="cursor-pointer" onClick={() => removeParticipant(participant.id)}>
            <CloseIcon />
          </div>
        </div>
      );
  }
}

export default observer(User);
